import { render, staticRenderFns } from "./PazientiListComponent.vue?vue&type=template&id=074ff5c4"
import script from "./PazientiListComponent.vue?vue&type=script&lang=js"
export * from "./PazientiListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports